import { BasePage } from '@/components/ui/base-page'

export function CleoPage() {
    return (
        <BasePage
            title="Cleo Estate Planning"
            description="Estate planning and advisory solutions"
        >
            {/* Add EstatePlanningPage specific content here */}
        </BasePage>
    )
} 